import React, { useState, useEffect } from 'react'

import Grid from '@mui/material/Grid';

import StockorderFilterCriteria from './StockorderFilterCriteria'
import StockorderListImpl from './StockorderListImpl'
import MyPageContainer from '../../core/template/MyPageContainer';
import {getListAPI} from './StockorderAPI';
import {transformToCardFormat} from '../../core/js/FormUtils'
import {getPathVariable} from '../../core/js/UrlUtils';

import { useSearchParams } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import {setStockorderDashboardStockorderList } from '../../store/slice/ManufSlice';

export default function StockorderListView({setShowEdit,setStockorderId}){
    const {filterCriteria} = useSelector((state)=>state.manufslice.stockorderDashboard);   

    const [filteredStockorderList, setFilteredStockorderList] = React.useState([]);
    const [cardList, setCardList] = useState([]);
    const [searchParams, setSearchParams] = useSearchParams();
    const { showfilter } = useSelector((state) => state.confslice);
    const { stockorderDashboard } = useSelector((state) => state.manufslice);
    
    function dataFetchCallBack(){
    }

    useEffect(()=>{
      if (stockorderDashboard.stockorderList.length>-1){
        setFilteredStockorderList(stockorderDashboard.stockorderList);
        transformToCardFormat(stockorderDashboard.stockorderList, setCardList);
      }
    },[stockorderDashboard.stockorderList])

    useEffect(()=>{
          transformToCardFormat(filteredStockorderList, setCardList);
      },[filteredStockorderList])

    useEffect(()=>{
        if (filterCriteria.title==='' && filterCriteria.partyid==='' && filterCriteria.partyname==='' && filterCriteria.orderstatusid==='' && filterCriteria.orderstatusname==='' && filterCriteria.remarks==='' && filterCriteria.partytypeid==='' ){
            setFilteredStockorderList(stockorderDashboard.stockorderList);
            transformToCardFormat(stockorderDashboard.stockorderList, setCardList);

        } else {
            setFilteredStockorderList(
                stockorderDashboard.stockorderList
                    .filter(stockorder=> stockorder.title.toString().toUpperCase().includes(filterCriteria.title.toString().toUpperCase()))

                
            )
            

            //transformToCardFormat(stockorderDashboard.filteredStockorderList, setCardList);
        }
      },[filterCriteria])
  
     return(
        <Grid container direction="column" >
            <Grid item lg={12}>
                <StockorderListImpl
                    setShowEdit={setShowEdit}
                    setStockorderId = {setStockorderId}
                    tableList={filteredStockorderList}
                    cardList={cardList}
                    />
          </Grid>
      </Grid>
    )
}